import { PaymentMethod } from "@stripe/stripe-js";

import { getAPIService, postAPIService } from "./BaseServce";

export const getPlans = async (subscriptionId: number) => {
  const res = await getAPIService("/payment/plans", {
    subscription_id: subscriptionId,
  });
  return res.data;
};
export const getPaymentMethods = async (subscriptionId: number) => {
  const res = await getAPIService(
    `/subscription/${subscriptionId}/payment-methods`,
  );
  return res.data;
};

export const getInvoices = async (
  subscriptionId: number,
  invoiceId?: number | string,
) => {
  const res = await getAPIService(`/subscription/${subscriptionId}/invoices`, {
    invoice_id: invoiceId,
  });
  return res.data;
};

export const createSetupIntent = async (subscriptionId: number) => {
  const res = await postAPIService(
    `/subscription/${subscriptionId}/setup-intent`,
  );
  return res.data;
};

export const setDefaultPaymentMethod = async (
  subscriptionId: number,
  paymentMethodId,
) => {
  const res = await postAPIService(
    `/subscription/${subscriptionId}/default-payment-method`,
    {
      payment_method_id: paymentMethodId,
    },
  );
  return res.data as PaymentMethod;
};

export const removePaymentMethod = async (
  subscriptionId: number,
  paymentMethodId,
) => {
  const res = await postAPIService(
    `/subscription/${subscriptionId}/remove-payment-method`,
    {
      payment_method_id: paymentMethodId,
    },
  );
  return res.data;
};

export const upgradePlan = async (
  subscriptionId: number,
  paymentMethodId,
  newPlanId,
) => {
  const res = await postAPIService(`/subscription/${subscriptionId}/upgrade`, {
    payment_method_id: paymentMethodId,
    new_plan_id: newPlanId,
  });
  return res.data;
};
export const downgradeSubscriptionPlan = async (
  subscriptionId: number,
  newPlanId,
) => {
  const res = await postAPIService(
    `/subscription/${subscriptionId}/downgrade-plan`,
    {
      new_plan_id: newPlanId,
    },
  );
  return res.data;
};
export const cancelPlan = async (subscriptionId: number, feedback?: string) => {
  const data = feedback?.length ? { feedback } : {};
  const res = await postAPIService(
    `/subscription/${subscriptionId}/cancel-plan`,
    data,
  );
  return res.data;
};
export const getCancellationCharges = async (subscriptionId: number) => {
  const res = await getAPIService(
    `/subscription/${subscriptionId}/cancel-plan`,
  );
  return res.data;
};
export const getUpgradeCharges = async (subscriptionId: number, newPlanId) => {
  const res = await getAPIService(`/subscription/${subscriptionId}/upgrade`, {
    new_plan_id: newPlanId,
  });
  return res.data;
};
export const exportUsage = async (
  subscriptionId: number,
  format: string,
  duration: string,
) => {
  const res = await postAPIService(
    `/subscription/${subscriptionId}/usage`,
    {
      format,
      duration,
    },
    "blob",
  );
  return res;
};

export const getThrottleUsageApi = async (subscriptionId: number) => {
  const res = await getAPIService(
    `/subscription/${subscriptionId}/throttle-usage`,
  );
  return res.data;
};
